import axios from 'axios';
// export NODE_OPTIONS=--openssl-legacy-provider
// import store from '@/store'; // 假设你有一个全局的Vuex store用于处理token等状态
import router from '@/router'
// 创建axios实例
const service = axios.create({
	baseURL: 'https://m.yikaotianbao.com', // 设置你的API基础URL
	// baseURL: 'http://192.168.1.99:887', // 设置你的API基础URL
	// baseURL: 'http://192.168.1.166', // 设置你的API基础URL
	timeout: 5000, // 请求超时时间
	withCredentials: false
});

// 请求拦截器 - 添加请求头、处理Token等
service.interceptors.request.use(config => {
	// 若存在token，则添加到headers中
	const token = localStorage.getItem('token');
	if (token) {
		config.headers.token = `${token}`;
	}
	config.headers.version = 'v2';
	return config;
}, error => {
	Promise.reject(error);
});

// 响应拦截器 - 处理响应结果、统一错误处理等
service.interceptors.response.use(
	response => {
		const {
			data
		} = response;
		if (data.code == 401) {
			localStorage.setItem('token', '');
			router.replace('/Login');
		}
		// if (data.code !== 200) {
		//   // 根据实际返回数据结构处理错误码
		//   // 这里假设非200为业务错误
		//   return Promise.reject(new Error(data.message || 'Error'));
		// }
		return data; // 根据实际情况返回有效数据部分
	},
	error => {
		console.error('请求异常:', error); // 打印错误日志
		if (error.response.status === 401) {
			localStorage.setItem('token', '');
			router.replace('/Login');
			// 例如：处理未授权的情况，如token过期
			// store.dispatch('auth/logout');
		}
		return Promise.reject(error);
	},
);

export default service;